module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/42.8ffc0e50.png";